import { Locales } from 'src/i18n'
import Translation from '../../shared/interfaces/Translation'
import ScheduledPeriodTranslationJson from 'src/models/rental/workflow/interfaces/ScheduledPeriodTranslationJson'

export default class ScheduledPeriodTranslation implements Translation {
  locale: Locales
  label: string
  subLabel: string | null

  constructor(locale: Locales, label: string, subLabel: string | null) {
    this.locale = locale
    this.label = label
    this.subLabel = subLabel
  }

  static fromJson(data: ScheduledPeriodTranslationJson) {
    return new this(data.locale, data.label, data.subLabel)
  }
}
